import { Component, Element, h, Host, Prop } from "@stencil/core";

import { Layout } from "../../index";

/**
 * @slot - Slot for e.g. image or video
 */
@Component({
  tag: "stzh-ratio",
  styleUrl: "stzh-ratio.scss",
  shadow: true,
})
export class StzhRatio {
  /** Aspect ratio */
  @Prop({ reflect: true }) ratio: Layout.Ratio = "16:9";
  /** Aspect ratio above small breakpoint */
  @Prop({ reflect: true }) ratioSmall: Layout.Ratio | "inherit" = "inherit";
  /** Aspect ratio above medium breakpoint */
  @Prop({ reflect: true }) ratioMedium: Layout.Ratio | "inherit" = "inherit";
  /** Aspect ratio above large breakpoint */
  @Prop({ reflect: true }) ratioLarge: Layout.Ratio | "inherit" = "inherit";
  /** Aspect ratio above ultra breakpoint */
  @Prop({ reflect: true }) ratioUltra: Layout.Ratio | "inherit" = "inherit";

  /** Whether aspect ratio is in portrait mode */
  @Prop({ reflect: true }) portrait: boolean = false;

  /** Fit mode */
  @Prop({ reflect: true }) fit: "cover" | "contain" = "cover";

  @Element() element: HTMLStzhRatioElement;

  render() {
    const classes = {
      "stzh-ratio": true,
    };

    return (
      <Host>
        <div class={classes}>
          <slot name="image"></slot>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
